import type React from "react";
import { Route, Routes } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import Layout from "./Layout.tsx";
import DashboardHome from "./DashboardHome.tsx";

const Dashboard: React.FC = () => {
  return (
    <Layout>
      <Box width="100%" maxWidth="1200px" mx="auto">
        <Routes>
          <Route path="/" element={<DashboardHome />} />
          {/* Add other routes for dashboard pages */}
          <Route path="*" element={<DashboardHome />} /> {/* Fallback route */}
        </Routes>
      </Box>
    </Layout>
  );
};

export default Dashboard;
